import { Shimmer } from '@components';

import { Container, Divider } from '../CurrentUsers.styles';

const MembersLoading = () => {
  return (
    <Container>
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Divider height="16px" />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Divider height="16px" />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Divider height="16px" />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};

export { MembersLoading };
